var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [!_vm.hideButton ? _c('v-btn', {
    attrs: {
      "elevation": 0
    },
    on: {
      "click": _vm.open
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("repairEstimate.createRequest")) + " ")]) : _vm._e(), _c('confirm-action-dialog', {
    attrs: {
      "isDialogActive": _vm.isDialogActive,
      "title": _vm.currentStep.title,
      "subtitle": _vm.currentStep.subtitle,
      "loading": _vm.currentStep.loading,
      "supressKeyboardActions": true,
      "rightLoading": _vm.currentStep.loading,
      "rightDisabled": _vm.currentStep.disabled,
      "leftText": _vm.currentStep.backText,
      "rightText": _vm.currentStep.nextText
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isDialogActive = $event;
      },
      "leftClick": function leftClick() {
        return _vm.currentStep.back();
      },
      "rightClick": function rightClick() {
        return _vm.currentStep.next();
      }
    }
  }, [_c('repair-estimate-create-stepper', {
    ref: "requestRepairEstimateStepper",
    attrs: {
      "step": _vm.step,
      "hideRefsSelect": _vm.hideRefsSelect,
      "sellerCompanyId": _vm.sellerCompanyId,
      "refsSelectAsList": _vm.refs.length === 0,
      "report": _vm.report
    },
    on: {
      "update:step": function updateStep($event) {
        _vm.step = $event;
      },
      "create:sharedContent": function createSharedContent($event) {
        return _vm.$emit('create:sharedContent', $event);
      }
    },
    model: {
      value: _vm.value,
      callback: function callback($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }